const wakeupCalls: Record<
  string,
  {
    status: string
    tip?: number
    wakeUp: () => void
    [key: string]: boolean | any
  }
> = {}

export function wakeupPayment(paymentId: string, status: string, tip?: number) {
  const call = wakeupCalls[paymentId]
  if (call) {
    call.status = status
    call.tip = tip
    call.wakeUp()
  }
}

// https://stackoverflow.com/a/51843228
export function wakeablePayment(paymentId: string) {
  return new Promise(resolve => {
    wakeupCalls[paymentId] = {
      status: '',
      tip: undefined,
      wakeUp: () => resolve(wakeupCalls[paymentId])
    }
  })
}
